import { useEffect, useState } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { Alert, Button, Card, Col, Container, Form, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeObjective } from "../../redux/evaluacion_desempenio/EmployeeObjective/actions";
import { getEvaluationMonitorById } from "../../redux/evaluacion_desempenio/EvaluationMonitor/actions";
import { getFormType } from "../../redux/evaluacion_desempenio/FormType/actions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import FileInput from "../../components/evaluacion_desempenio/EmployeeObjectives/FileInput";
import { getBossCompetency, getEmployeeCompetency } from "../../redux/evaluacion_desempenio/EvaluationCompetency/actions";
import { getBossValue, getEmployeeValue } from "../../redux/evaluacion_desempenio/EvaluationValue/actions";
import { getObjectiveMetric } from "../../redux/evaluacion_desempenio/ObjectiveMetric/actions";

const ObjectivesEvaluationSummary = () => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const { idEvaluacion, idEvaluacionGeneral, idConfiguracion } = useParams();

    const {
        loading: loadingObjectives,
        employeeObjectives,
        employeeObjectiveError
    } = useSelector((store) => store.employeeObjective);

    const {
        loadingById: loadingEvaluationMonitor,
        evaluationMonitor,
        evaluationMonitorError
    } = useSelector((store) => store.evaluationMonitor);

    const {
        loading: loadingObjectiveMetric,
        objectiveMetrics,
        objectiveMetricError
    } = useSelector((store) => store.objectiveMetric);

    const {
        loading: loadingFormType,
        formTypes,
        formTypeError
    } = useSelector((store) => store.formType);

    const {
        loadingEmployeeValue,
        employeeValues,
        employeeValueError,

        loadingBossValue,
        bossValues,
        bossValueError
    } = useSelector((store) => store.evaluationValue);

    const {
        loadingEmployeeCompetency,
        employeeCompetencies,
        employeeCompetencyError,

        loadingBossCompetency,
        bossCompetencies,
        bossCompetencyError
    } = useSelector((store) => store.evaluationCompetency);

    //Obtener los tipos de formulario para saber si la evaluación incluye evaluación por competencias o por valores
    const competencyEvaluationId = formTypes?.find(ft => ft?.nombre?.toLowerCase().includes("competencias"))?.id;
    const valueEvaluationId = formTypes?.find(ft => ft?.nombre?.toLowerCase().includes("valores"))?.id;
    const isCompetencyEval = evaluationMonitor?.data_evaluacion_objetivos?.formularios?.some(ft => ft.formulario__id === competencyEvaluationId) ?? null;
    const isValueEval = evaluationMonitor?.data_evaluacion_objetivos?.formularios?.some(ft => ft.formulario__id === valueEvaluationId) ?? null;

    const pillarsData = isCompetencyEval ? employeeCompetencies?.competencias_pilares : employeeValues?.valores_pilares;

    useEffect(() => {
        dispatch(getEmployeeObjective({
            empleado_evaluacion: idEvaluacion
        }))
        dispatch(getEvaluationMonitorById(idEvaluacionGeneral))
        dispatch(getFormType())
        dispatch(getObjectiveMetric({ configuracion: idConfiguracion }))

    }, [])

    useEffect(() => {
        if (!evaluationMonitor) return;

        if (!isCompetencyEval && !isValueEval) return;
        if (isCompetencyEval) {
            dispatch(getEmployeeCompetency({ evaluacion_empleado: idEvaluacion }));
            dispatch(getBossCompetency({ evaluacion_empleado: idEvaluacion }))
        } else if (isValueEval) {
            dispatch(getEmployeeValue({ evaluacion_empleado: idEvaluacion }));
            dispatch(getBossValue({ evaluacion_empleado: idEvaluacion }))
        }

    }, [evaluationMonitor, formTypes])


    const getQuestionAnswer = (pillar_question, data) => {
        let answer = data?.data?.find(dataQuestion => (isCompetencyEval ? dataQuestion?.competencia_data : dataQuestion?.valor_data).id === pillar_question.id);
        let answerValue = objectiveMetrics.find(metric => metric.id === answer?.metrica)?.escala;
        return answerValue

    }


    const Results = ({ employeeResult, bossResult }) => {
        return (
            <div className="my-3">
                <Container fluid>
                    <Row>
                        <Col xs={12} md={6} className="mb-3">
                            <Row>
                                <Col className="text-white py-3" style={{ backgroundColor: "#3a3d3fff" }}>
                                    Resultado Autoevaluación
                                </Col>
                                <Col className="text-center py-3 bg-light">
                                    {employeeResult || "-"}
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} md={6} className="mb-3">
                            <Row>
                                <Col className="text-white py-3" style={{ backgroundColor: "#343a40ff" }}>
                                    Resultado Evaluación Jefe
                                </Col>
                                <Col className="text-center py-3 bg-light">
                                    {bossResult || "-"}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    const onShowSidebar = () => setShow(show ? false : true);
    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    {(loadingEvaluationMonitor || loadingFormType) ? (
                        <div className="text-center my-5">
                            <Spinner animation="border" role="status" size="sm" />
                        </div>
                    ) :
                        (
                            <div>
                                <h3 className="mb-4">Resumen de Evaluación</h3>
                                <Alert variant="danger" show={evaluationMonitorError || employeeObjectiveError || formTypeError}>
                                    {evaluationMonitorError || employeeObjectiveError || formTypeError}
                                </Alert>
                                <div>
                                    <Card className="mb-4">
                                        <Card.Header className="bg-dark text-white"><strong>Datos del Evaluador</strong></Card.Header>
                                        <Card.Body>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group as={Row} className="mb-3" controlId="evaluatorName">
                                                        <Form.Label column md={4}>
                                                            Nombre:
                                                        </Form.Label>
                                                        <Col md={8}>
                                                            <Form.Control type="text" value={evaluationMonitor?.list_evaluador?.[0]?.nombre} readOnly className="rounded-pill" />
                                                        </Col>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group as={Row} className="mb-3" controlId="evaluatorFunction">
                                                        <Form.Label column md={4}>
                                                            Función:
                                                        </Form.Label>
                                                        <Col md={8}>
                                                            <Form.Control type="text" value={`${evaluationMonitor?.list_evaluador?.[0]?.Funciones_List?.[0]?.codigo}/${evaluationMonitor?.list_evaluador?.[0]?.Funciones_List?.[0]?.descripcion}`} readOnly className="rounded-pill" />
                                                        </Col>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group as={Row} className="mb-3" controlId="evaluatorRelationship">
                                                        <Form.Label column md={4}>
                                                            Relación:
                                                        </Form.Label>
                                                        <Col md={8}>
                                                            <Form.Control type="text" value="Jefe inmediato" readOnly className="rounded-pill" />
                                                        </Col>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>

                                    <Card className="mb-4">
                                        <Card.Header className="bg-dark text-white"><strong>Datos del Evaluado</strong></Card.Header>
                                        <Card.Body>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group as={Row} className="mb-3" controlId="evaluatedName">
                                                        <Form.Label column md={4}>
                                                            Nombre:
                                                        </Form.Label>
                                                        <Col md={8}>
                                                            <Form.Control type="text" value={evaluationMonitor?.list_evaluado?.[0]?.nombre} readOnly className="rounded-pill" />
                                                        </Col>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group as={Row} className="mb-3" controlId="evaluatedFunction">
                                                        <Form.Label column md={4}>
                                                            Función:
                                                        </Form.Label>
                                                        <Col md={8}>
                                                            <Form.Control type="text" value={`${evaluationMonitor?.list_evaluado?.[0]?.Funciones_List?.[0]?.codigo}/${evaluationMonitor?.list_evaluado?.[0]?.Funciones_List?.[0]?.descripcion}`} readOnly className="rounded-pill" />
                                                        </Col>
                                                    </Form.Group>
                                                </Col>

                                            </Row>
                                        </Card.Body>
                                    </Card>

                                    <Card className="mb-4">
                                        <Card.Header className="bg-dark text-white"><strong>Evaluación por Objetivos</strong></Card.Header>
                                        {
                                            loadingObjectives ? (
                                                <div className="text-center my-5">
                                                    <Spinner animation="border" role="status" size="sm" />
                                                </div>
                                            ) : (
                                                <Card.Body>
                                                    <Alert variant="danger" show={employeeObjectiveError}>
                                                        {employeeObjectiveError}
                                                    </Alert>
                                                    <Table striped bordered hover responsive>
                                                        <thead>
                                                            <tr>
                                                                <th>Pilar Estratégico</th>
                                                                <th style={{ minWidth: "250px" }}>Objetivo</th>
                                                                <th>Peso</th>
                                                                <th style={{ minWidth: "250px" }}>Indicador</th>
                                                                <th>Autoevaluación</th>
                                                                <th style={{ minWidth: "250px" }}>Comentario jefe</th>
                                                                <th colSpan={2}>Evaluación jefe</th>
                                                                <th>Evidencias</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {employeeObjectives?.map((obj) => (
                                                                <tr key={obj.id}>
                                                                    <td>{obj.pilar_estrategico_data?.nombre}</td>
                                                                    <td>{obj.nombre}</td>
                                                                    <td>{obj.peso}</td>
                                                                    <td>{obj.indicador}</td>
                                                                    <td>{obj.nota_empleado}</td>
                                                                    <td>{obj.comentario}</td>
                                                                    <td>{obj.nota_jefe}</td>
                                                                    <td>{obj.metrica_nombre_data}</td>
                                                                    <td>
                                                                        <FileInput
                                                                            value={obj?.archivo}
                                                                            isEditing={false}
                                                                        />
                                                                    </td>

                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>

                                                    <Results
                                                        employeeResult={employeeObjectives?.[0]?.empleado_evaluacion_data?.nota_empleado_final?.metrica_total}
                                                        bossResult={employeeObjectives?.[0]?.empleado_evaluacion_data?.nota_jefe_final?.metrica_total}
                                                    />
                                                </Card.Body>
                                            )
                                        }
                                    </Card>

                                    <Card className="mb-4">
                                        <Card.Header className="bg-dark text-white"><strong>{isCompetencyEval ? "Evaluación por Competencias" : "Evaluación por Valores"}</strong></Card.Header>
                                        {(loadingEmployeeCompetency || loadingBossCompetency || loadingEmployeeValue || loadingBossValue || loadingObjectiveMetric) ? (
                                            <div className="text-center my-5">
                                                <Spinner animation="border" role="status" size="sm" />
                                            </div>
                                        ) : (
                                            <Card.Body>
                                                <Alert variant="danger" show={employeeCompetencyError || bossCompetencyError || employeeValueError || bossValueError || objectiveMetricError}>
                                                    {employeeCompetencyError || bossCompetencyError || employeeValueError || bossValueError || objectiveMetricError}
                                                </Alert>
                                                <Table striped bordered hover responsive>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">
                                                                {isCompetencyEval ? "Competencias" : "Valores"}
                                                            </th>
                                                            <th className="text-center">Comportamiento(s)</th>
                                                            {/* Encabezados de métricas */}
                                                            <th>
                                                                Autoevaluación
                                                            </th>
                                                            <th>
                                                                Evaluación Jefe
                                                            </th>
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        {/* Filas de datos */}
                                                        {pillarsData?.map((pilarItem, pilarItemIndex) => {
                                                            // Selecciona las preguntas del pilar según el tipo
                                                            const questions = isCompetencyEval ? pilarItem?.competencias : pilarItem?.valores;
                                                            return questions?.map((questionItem, questionIndex) => {

                                                                let empAnswer = getQuestionAnswer(questionItem, isCompetencyEval ? employeeCompetencies : employeeValues);
                                                                let bossAnswer = getQuestionAnswer(questionItem, isCompetencyEval ? bossCompetencies : bossValues);
                                                                return (
                                                                    <tr key={questionItem?.id ?? `${pilarItemIndex}-${questionIndex}`}>
                                                                        {questionIndex === 0 && (
                                                                            <td rowSpan={questions?.length}>
                                                                                {pilarItem.pilar_nombre}
                                                                            </td>
                                                                        )}
                                                                        <td>
                                                                            {questionItem?.nombre}
                                                                        </td>
                                                                        <td>
                                                                            {empAnswer ? empAnswer : "-"}
                                                                        </td>
                                                                        <td>
                                                                            {bossAnswer ? bossAnswer : "-"}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            });
                                                        })}
                                                    </tbody>
                                                </Table>

                                                {
                                                    isCompetencyEval ? (
                                                        <Results
                                                            employeeResult={employeeCompetencies?.data?.[0]?.empleado_evaluacion_data?.nota_competencias_empleado_final?.metrica_total}
                                                            bossResult={bossCompetencies?.data?.[0]?.jefe_evaluacion_data?.nota_competencias_jefe_final?.metrica_total}
                                                        />
                                                    ) : (
                                                        <Results
                                                            employeeResult={employeeValues?.data?.[0]?.empleado_evaluacion_data?.nota_valores_empleado_final?.metrica_total}
                                                            bossResult={bossValues?.data?.[0]?.empleado_evaluacion_data?.nota_valores_jefe_final?.metrica_total}
                                                        />
                                                    )
                                                }
                                            </Card.Body>
                                        )}

                                    </Card>

                                    <Card className="mb-4">
                                        <Card.Header className="bg-dark text-white"><strong>Comentarios Generales</strong></Card.Header>
                                        {(loadingEmployeeCompetency || loadingBossCompetency || loadingEmployeeValue || loadingBossValue) ? (
                                            <div className="text-center my-5">
                                                <Spinner animation="border" role="status" size="sm" />
                                            </div>
                                        ) : (
                                            <Card.Body>
                                                <Alert variant="danger" show={employeeCompetencyError || bossCompetencyError || employeeValueError || bossValueError}>
                                                    {employeeCompetencyError || bossCompetencyError || employeeValueError || bossValueError}
                                                </Alert>
                                                <div className="my-4 p-3">
                                                    <Row>
                                                        <Col className="border p-3 text-center" style={{ fontWeight: "bold" }} xs={9}>CALIFICACIÓN GENERAL DEL EMPLEADO</Col>
                                                        <Col className="border text-center p-3" xs={3}> {evaluationMonitor?.data_evaluacion_objetivos?.clasificacion_nota_empleado} </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className="border p-3" style={{ fontWeight: "bold" }} xs={3}>Comentario General Empleado: (250 caracteres incluyendo espacios)</Col>
                                                        <Col className="bg-light border p-3" xs={9}>
                                                            <Form.Control
                                                                as="textarea"
                                                                maxLength={250}
                                                                value={isCompetencyEval ? employeeCompetencies?.data?.[0]?.empleado_evaluacion_data?.comentario_general_empleado :
                                                                    employeeValues?.data?.[0]?.empleado_evaluacion_data?.comentario_general_empleado
                                                                }
                                                                disabled
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className="my-4 p-3">
                                                    <Row>
                                                        <Col className="border p-3 text-center" style={{ fontWeight: "bold" }} xs={9}>CALIFICACIÓN GENERAL DEL JEFE</Col>
                                                        <Col className="border text-center p-3" xs={3}> {evaluationMonitor?.data_evaluacion_objetivos?.clasificacion_nota_jefe} </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className="border p-3" style={{ fontWeight: "bold" }} xs={3}>Comentario General Jefe: (250 caracteres incluyendo espacios)</Col>
                                                        <Col className="bg-light border p-3" xs={9}>
                                                            <Form.Control
                                                                as="textarea"
                                                                maxLength={250}
                                                                value={isCompetencyEval ? bossCompetencies?.data?.[0]?.empleado_evaluacion_data?.comentario_general_jefe :
                                                                    bossValues?.data?.[0]?.empleado_evaluacion_data?.comentario_general_jefe
                                                                }
                                                                disabled

                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>

                                            </Card.Body>
                                        )}
                                    </Card>
                                </div>

                            </div>
                        )
                    }


                </Container>
            </div>
        </>
    )
}

export default ObjectivesEvaluationSummary;